/*
  World Wide Wet — pestañas de información operables con teclado.

  El componente info-tabs del tema (Combine) dibuja cada pestaña como un
  <span class="js-info-tab"> sin tabindex, sin role y sin aria. Solo la primera
  lleva .active; las demás tienen su texto en display:none.

  Consecuencia real, medida: con teclado o lector de pantalla NO hay forma de
  abrir las otras pestañas, y su contenido directamente no existe. En la sección
  de autoridad eso esconde dos de los tres puntos — justo los que hay que leer.

  Esto NO reimplementa el componente ni toca su lógica: le agrega la semántica
  que le falta y le reenvía un click a su propio manejador. Si el tema cambia su
  JS interno, esto sigue funcionando, porque lo único que hace es simular el
  gesto que el tema ya escucha.
*/
(function () {
  'use strict';

  var MARCA = 'wwtA11y';

  function preparar(tab) {
    // idempotente: el editor de temas re-renderiza secciones a cada rato
    if (tab.dataset[MARCA]) return;
    tab.dataset[MARCA] = '1';

    tab.setAttribute('tabindex', '0');
    tab.setAttribute('role', 'button');
    sincronizar(tab);

    tab.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      // Espacio scrollea la página si no se frena
      e.preventDefault();
      tab.click();
    });

    // El tema añade y quita .active por su cuenta; aria lo sigue desde afuera.
    new MutationObserver(function () { sincronizar(tab); })
      .observe(tab, { attributes: true, attributeFilter: ['class'] });
  }

  function sincronizar(tab) {
    tab.setAttribute('aria-expanded', tab.classList.contains('active') ? 'true' : 'false');
  }

  /*
    Segundo arreglo, otro componente: content-toggles.

    Ese sí trae la semántica de fábrica —role="button", tabindex, aria-controls—
    pero tiene dos agujeros medidos en el sitio:

    1. Su JS escucha SOLO click. Con Enter o barra espaciadora no pasa nada. O
       sea: se anuncia como botón, recibe el foco, y no se puede accionar. Un
       botón falso es peor que un div, porque promete algo que no cumple.

    2. El toggle que abre por defecto (open_first) nace con aria-expanded="false"
       escrito en el marcado y nadie lo corrige. El tema sí sincroniza al hacer
       clic, pero nunca al cargar: un lector de pantalla anuncia "colapsado" un
       panel que está abierto.

    Se resuelven sin tocar el componente: se le reenvía un click, que es el gesto
    que su propio JS ya escucha, y se sigue la clase .opened, que es la que el
    propio tema mueve.
  */
  function prepararToggle(tab) {
    if (tab.dataset[MARCA]) return;
    tab.dataset[MARCA] = '1';

    var titulo = tab.querySelector('.toggle__title');
    if (!titulo) return;

    titulo.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      titulo.click();
    });

    var sinc = function () {
      titulo.setAttribute('aria-expanded', tab.classList.contains('opened') ? 'true' : 'false');
    };
    sinc();
    new MutationObserver(sinc).observe(tab, { attributes: true, attributeFilter: ['class'] });
  }

  function barrer(raiz) {
    var r = raiz || document;
    r.querySelectorAll('.js-info-tab').forEach(preparar);
    r.querySelectorAll('toggle-tab').forEach(prepararToggle);
  }

  function arrancar() {
    barrer();
    // Secciones que llegan después: editor de temas, carga diferida, apps.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodos = muts[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          if (nodos[j].nodeType !== 1) continue;
          var n = nodos[j];
          if (n.matches && n.matches('.js-info-tab')) preparar(n);
          else if (n.matches && n.matches('toggle-tab')) prepararToggle(n);
          else barrer(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
